// extracted by mini-css-extract-plugin
module.exports = {"FiveStars":"FiveStars_FiveStars__1Gi2t"};